// TaskList.tsx
import React from "react";
import { TaskType } from "./Task/Types";
import { Task } from "./Task/Task";

type TaskListProps = {
  tasks: TaskType[];
  onMoveTask: (dragIndex: number, hoverIndex: number) => void;
};

export const TaskList: React.FC<TaskListProps> = ({ tasks, onMoveTask }) => {
  const renderTask = (task: TaskType, index: number) => {
    return (
      <Task key={task.id} task={task} index={index} onMoveTask={onMoveTask} />
    );
  };

  return <div>{tasks.map(renderTask)}</div>;
};